import { useClipboard } from '@vueuse/core'

const copyText = async (text: string, success: () => void, error: () => void) => {
  const { copy, isSupported } = useClipboard()
  if (isSupported.value) {
    try {
      await copy(text)
      success()
    } catch (_error) {
      error()
    }
  } else {
    // 降级方案：使用传统方法
    try {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      success()
    } catch (_error) {
      error()
    }
  }
}

export default copyText
